import React, { memo, useCallback, useMemo } from 'react';
import { useTheme } from '@Sage/hoi-poi-ui';

import LazyRichText from 'components/LazyRichText';

import { getEditorToolbar } from './utils';

import './styles.scss';

const RichTextInput = memo(({ defaultValue, hint, onChange, isReadOnly }) => {
    const theme = useTheme();

    const handleChange = useCallback(
        (value) => {
            if (!onChange) return;

            onChange({
                html: value?.html || null,
                text: value?.text || null,
            });
        },
        [onChange],
    );

    const editorProps = useMemo(
        () => ({
            isFullWidth: true,
            isReadOnly,
            onChange: handleChange,
            overrides: {
                editorWrapper: {
                    style: {
                        backgroundColor: theme.colors.primary.white,
                    },
                },
                editor: {
                    style: {
                        color: theme.colors.utility.textPrimary,
                    },
                },
            },
            placeholder: hint,
            toolbar: getEditorToolbar(),
            toolbarStyle: 'fixed',
            value: defaultValue || '',
        }),
        [
            defaultValue,
            handleChange,
            hint,
            isReadOnly,
            theme.colors.primary.white,
            theme.colors.utility.textPrimary,
        ],
    );

    return (
        <div className="fm-richtext">
            <LazyRichText {...editorProps} />
        </div>
    );
});

RichTextInput.displayName = 'RichTextInput';

export default RichTextInput;
